<template>
  <div class="container">
    <div class="momentum">
      <p class="title">
        Momentum
      </p>
      <Tracker
        name="momentum"
        :event="event"
        :event-id="eventId"
        :width="width"
      />
    </div>

    <div class="statistics">
      <p class="title">
        Statistics
      </p>
      <StatWidgets
        :event="event"
        :event-id="eventId"
        :sport-id="event.sportId"
        :round-type="event.roundType"
        :start-time="event.startTime"
        tabs-position="top"
        :nav-fixed-offset-top="44"
      />
    </div>
  </div>
</template>

<script>
import Tracker from '@ms/components/Tracker'

export default {
  name: 'Stats',
  components: {
    Tracker,
    StatWidgets: () => import(/* webpackPrefetch: true, webpackChunkName: 'stat-widgets' */ 'wap/components/StatWidgets')
  },
  props: {
    width: {
      type: Number,
      default: 0
    },
    event: {
      type: Object,
      required: true
    },
    eventId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      list: [
        {
          label: 'Momentum',
          name: 'momentum'
        },
        {
          label: 'Statistics',
          name: 'stttcs',
          children: [
            {
              label: 'H2H',
              name: 'h2h'
            },
            {
              label: 'Table',
              name: 'liveTable'
            },
            {
              label: 'Standings',
              name: 'standings'
            }
          ]
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  padding-bottom: 50px;
  background: #222;

  .title {
    display: flex;
    width: 100%;
    height: 40px;
    align-items: center;
    background: #000;
    color: #fff;
    font-size: 14px;
    font-weight: 500;

    &::before {
      width: 4px;
      height: 18px;
      margin-right: 6px;
      background: #ffca27;
      content: "";
    }
  }
}
</style>
